export * from './room-details';
export * from './room-details.props';
